import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import useInvoiceTaxes from 'Hooks/useInvoiceTaxes';
import SelectSingleTaxField from './SelectSingleTaxField';

const SelectSingleTax = forwardRef(function SelectSingleTax(props, ref) {
    const { invoiceTaxes, isLoading } = useInvoiceTaxes(props.value ? [props.value] : []);

    if (isLoading) return <div className="h-11" />;

    return <SelectSingleTaxField {...props} invoiceTaxes={invoiceTaxes} ref={ref} />;
});

export default SelectSingleTax;

SelectSingleTax.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    excludeIds: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
